import React from 'react';
import { Progress, Button, Modal, ModalHeader, ModalFooter, ModalBody, Dropdown, DropdownMenu, DropdownToggle, DropdownItem, Form, FormGroup, FormText, Label, Input } from 'reactstrap';
import $ from 'jquery';
import ValidatedTextBox from '../ValidatedTextBox'
import { withAlert } from 'react-alert'

class EditDocumentFormModal extends React.Component {
  constructor(props) {
    super(props);

    this.attemptSave = this.attemptSave.bind(this);
    this.genericOnChange = this.genericOnChange.bind(this);

    var controls = [];

    this.state = {
      allowSave: 'disabled',
      documentType: {},
      metaFieldz: [],
      standardControls: [],
      documentData: {},
      documentMetaData: {},
    };

  }

  componentDidMount = () => {
    if (this.props.editMetaData)
      this.setState({
        documentMetaData: this.props.editMetaData
      })
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.editMetaData !== prevProps.editMetaData)
      this.setState({
        documentMetaData: this.props.editMetaData
      })
  }

  genericOnChange(valid, e) {
    var found = false;
    var foundThisControl = false;

    for (var i = 0; i < this.state.standardControls.length; i++) {
      if (this.state.standardControls[i].id === e.currentTarget.id) {
        this.state.standardControls[i].valid = valid
        this.forceUpdate();
        foundThisControl = true;
      }

      if (!this.state.standardControls[i].valid) {
        found = true;
        break;
      }

    }

    var control = { id: e.currentTarget.id, valid: valid };

    if (!foundThisControl)
      this.setState(prevState => ({ standardControls: [...prevState.standardControls, control] }));

    if (!found)
      this.setState({ allowSave: '' });
    else
      this.setState({ allowSave: 'disabled' });

    let id = e.target.id;
    let value = e.target.value;

    let documentMetaData = { ...this.state.documentMetaData };
    documentMetaData[id] = value;

    this.setState({
      documentMetaData
    })
  }

  attemptSave() {
    try {
      //update the metadata.
      var found = false;
      for (var i = 0; i < this.state.standardControls.length; i++) {
        if (!this.state.standardControls[i].valid) {
          found = true;
          break;
        }
      }

      if (!found)
        this.setState({ allowSave: 'disabled' });
      else {
        this.setState({ allowSave: 'disabled' });
        return;
      }

      var documentData = {};

      if (this.props.DocTypeConfig !== undefined) {
        if (this.props.DocTypeConfig.Fields !== undefined && this.props.DocTypeConfig.Fields.length !== 0) {
          this.props.DocTypeConfig.Fields.forEach
            (
              field => {
                documentData[field.Name] = $("#" + field.Name).val();
              }
            );
        }
      }

      //update the fields
      this.state.documentMetaData.DocumentData = documentData;

      var data = new FormData();
      data.append("metaData", JSON.stringify(this.state.documentMetaData));

      $("#pleaseWait").removeAttr("style");
      fetch(window.location.protocol + '//' + window.location.host + "/api/archive/documents",
        {
          method: "PUT",
          body: data
        })
        .then(() => {
          $("#cancelButton").click();
          this.setState({ allowSave: '' });
        })
        .catch((error) => {
          //display an error 
          //TODO: how??
          this.setState({ allowSave: '' });
          console.error(error);
        });

    }
    catch (error) {
      console.error(error);
    }
  }

  render() {
    var metaFields = [];
    var local = 'en'; //todo change the localization

    if (this.props.DocTypeConfig !== undefined && this.props.editMetaData !== undefined) {
      if ((this.props.DocTypeConfig.Fields !== undefined && this.props.DocTypeConfig.Fields.length !== 0) && this.props.editMetaData.DocumentData !== undefined) {
        //Add a header
        metaFields.push(<header class="s-h2-head"><div class="s-h2-title">{this.props.DocTypeConfig.Description[local]} Properties</div></header>);

        this.props.DocTypeConfig.Fields.forEach
          (
            field => {
              switch (field.Type) {
                case "String":
                  metaFields.push(<ValidatedTextBox isEnabled={this.props.allowEdit} value={this.props.editMetaData.DocumentData[field.Name]} id={field.Name} labelText={field.Description[local] + ":"} onChange={this.genericOnChange} mandatory={field.Mandatory} />);
                  //this.setState(prevState => ({standardControls: [...prevState.standardControls, { id:field.Name,valid:field.Mandatory?false:true }]}));
                  break;
                case "Array":
                  if (this.props.editMetaData.DocumentData[field.Name] && this.props.editMetaData.DocumentData[field.Name].length > 0) {
                    this.props.editMetaData.DocumentData[field.Name].forEach((item, i) => {
                      metaFields.push(<ValidatedTextBox isEnabled={this.props.allowEdit} value={item} id={field.Name + i} labelText={field.Description[local] + ":"} onChange={this.genericOnChange} mandatory={field.Mandatory} />);
                    });
                  }
                  break;
                default:
                  break;
              }
            }
          );
      }
    }

    var style = {};
    style.display = 'none';
    return (
      <Modal isOpen={this.props.editmodal} toggle={this.props.toggleEditModal} className='modal-dialog'>
        <ModalHeader toggle={this.props.toggleEditModal}>View Document Info</ModalHeader>
        <ModalBody>
          <Form>
            <ValidatedTextBox isEnabled={false} value={this.props.DocumentRef} id="DocumentRef" labelText="Document Ref:" onChange={this.genericOnChange} mandatory={true} />
            <ValidatedTextBox isEnabled={false} value={this.props.DocTypeConfig.Description.en} id="DocumentType" labelText="Document Type:" onChange={this.genericOnChange} mandatory={true} />
            <ValidatedTextBox isEnabled={false} value={this.props.SecondRef} id="SecondRef" labelText="Second Ref:" onChange={this.genericOnChange} mandatory={true} />
            {this.props.file.Folder &&
              <ValidatedTextBox isEnabled={false} value={this.props.file.Folder} id="Folder" labelText="Folder:" />
            }
            {this.props.file.TransactionType &&
              <ValidatedTextBox isEnabled={false} value={this.props.file.TransactionType} id="TransactionType" labelText="Transaction Type:" />
            }
            {this.props.file.Company &&
              <ValidatedTextBox isEnabled={false} value={this.props.file.Company} id="Company" labelText="Company:" />
            }
            {this.props.file.TransactionValue &&
              <ValidatedTextBox isEnabled={false} value={this.props.file.TransactionValue} id="TransactionValue" labelText="Transaction Value:" />
            }
            {this.props.file.TransactionNumber &&
              <ValidatedTextBox isEnabled={false} value={this.props.file.TransactionNumber} id="TransactionNumber" labelText="Transaction Number:" />
            }
            {this.props.file.TransactionDate &&
              <ValidatedTextBox isEnabled={false} value={this.props.file.TransactionDate} id="TransactionDate" labelText="Transaction Date:" />
            }
            <ValidatedTextBox isEnabled={false} value={this.props.Version} id="Version" labelText="Version:" onChange={this.genericOnChange} mandatory={true} />
            <ValidatedTextBox isEnabled={false} value={this.props.DateTimeCreated} id="DateTimeCreated" labelText="Date Time Created:" onChange={this.genericOnChange} mandatory={true} />
            <ValidatedTextBox isEnabled={false} value={this.props.UserName} id="UserName" labelText="User Name:" onChange={this.genericOnChange} mandatory={true} />
            <ValidatedTextBox isEnabled={false} value={this.props.ImportType} id="ImportType" labelText="Import Type:" onChange={this.genericOnChange} mandatory={true} />
            <br />
            <div id='metaData'>
              {
                metaFields
              }
            </div>
          </Form>
          <Progress id="pleaseWait" style={style} animated color="success" value="100" />
        </ModalBody>
        <ModalFooter>
          <Button color="primary" disabled={this.state.allowSave} onClick={this.attemptSave}>Save</Button>
          <Button id="cancelButton" color="secondary" onClick={this.props.toggleEditModal}>Cancel</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default EditDocumentFormModal; 
